import { useQuery } from '@tanstack/react-query';
import { apiRequests } from '../apiRequests.js';

export const useGetCountries = () => {
  const { data, error, isLoading } = useQuery({
    queryKey: ['getCountries'],
    queryFn: () => apiRequests.countries.get(200),
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return {
    data,
    error,
    isLoading,
  };
};
